export const tokenName = 'userToken';

export const personalInfoName = 'personalInfo';

export const platFormName = 'platForm';

export const signKey = "Sign";
